// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle-icon {\n  margin-right: 5px;\n}\n.subtitle-account {\n  padding-bottom: 5px;\n  display: flex;\n  align-items: center;\n}\n.subtitle-account span {\n  font-size: 0.75em;\n  font-weight: bold;\n  margin-left: 3px;\n}\n.opacity_ {\n  opacity: 0.3;\n}\n.design-select .v-input__slot {\n  height: 35px;\n}", ""]);
// Exports
module.exports = exports;
